import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles(theme => ({
  dropzone: {
    minHeight: "400px",
    background: "rgb(139,195,74,20%)",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
    padding: "15px 10px",
    cursor: "pointer",
    width: "80%",
    border: "#8bc34a dashed 2px",
    outline: "none",
    textAlign: "center",
    marginBottom: "15px",
    color: "#a7b1eb",
    transition: "background 0.2s",
    "& p": {
      fontWeight: "bold"
    },
    "@media (max-width: 600px)": {
      width: "100%"
    }
  },
  dragActive: {
    background: "rgb(167, 177, 235, 40%);"
  },
  dragAccept: {
    background: "rgb(139, 195, 74, 40%)"
  },
  dragReject: {
    color: "rgb(255, 0, 0, 40%)",
    border: "rgb(255, 0, 0, 40%) dashed 2px"
  },
  btnUpload: {
    backgroundColor: "#8bc34a",
    color: "#fff",
    padding: "10px",
    boxShadow: "none",
    width: "100%",
    "&:hover": {
      backgroundColor: "#7ab633",
      boxShadow: "none"
    }
  },
  actionContainer: {
    width: "80%",
    marginTop: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    "@media (max-width: 600px)": {
      width: "100%"
    }
  },
  dateContainer: {
    width: "80%",
    marginBottom: theme.spacing(2),
    "@media (max-width: 600px)": {
      width: "100%"
    }
  },
  progress: {
    width: "100%",
    maxWidth: "500px",
    marginTop: theme.spacing(2)
  }
}));
